<!--
models [
  {
    icon: 'fa fa-users',
    title: 'Admin Information',
    percentage: '',
  }
]
-->

<template>
  <ul class="process-model">
    <li
      v-for="(model, key) in models"
      :class="getIconClass(key)">
      <a @click="changeStage(key)">
        <div :class="{
          'active-wrap': stage === key,
          'visited-wrap' : stage !== key && key < maxStage }">
          <i
          :class="model.icon"
          aria-hidden="true"/>
        </div>
        <p
          class="no-margin"
          v-html="model.title"/>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    models: {
      type: Array,
      default: () => [],
      required: true,
    },
    maxStage: {
      type: Number,
      default: 0,
      required: true,
    },
    currentStage: {
      type: Number,
      default: -1,
      required: false,
    },
    disableMaxStageUpdate: {
      type: Boolean,
      default: false,
      required: false,
    }
  },

  data() {
    return {
      stage: 0,
    };
  },

  watch: {
    maxStage(val) {
      if (!this.disableMaxStageUpdate) {
        this.stage = val;
        this.$emit('current-stage', this.stage);
      }
    },

    currentStage(val) {
      if (val >= 0) {
        this.stage = val;
      }
    },
  },

  methods: {
    getIconClass(stage) {
      return `${stage === this.stage ? 'active' : ''} ${this.maxStage > stage ? 'visited' : ''}`;
    },

    changeStage(stage) {
      if (stage <= this.maxStage) {
        this.stage = stage;
        this.$emit('current-stage', this.stage);
      }
    },
  },
};
</script>
<style scoped>

@media screen and (max-width: 700px) {
  .process-model {
    visibility: hidden;
    display: none;
  }
}

.process-model {
  list-style: none;
  padding: 0;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
  border: none;
  z-index: 0;
  direction: ltr;
}

.process-model li::after {
  background: #e5e5e5 none repeat scroll 0 0;
  bottom: 0;
  content: "";
  display: block;
  height: 4px;
  margin: 0 auto;
  position: relative;
  right: -50px;
  top: -80px;
  width: 85%;
  z-index: -1;
}

.process-model li.visited::after {
  background: #57b87b;
}

.process-model li:last-child::after {
  width: 0;
}

.process-model li {
  display: inline-block;
  width: 18%;
  text-align: center;
  float: none;
}

.process-model li a {
  padding: 0;
  border: none;
  color: #606060;
  cursor: default;
}

.process-model li.active,
.process-model li.visited {
  color: #57b87b;
}

.process-model li.active a,
.process-model li.active a:hover,
.process-model li.active a:focus {
  color: #606060;
  cursor: pointer;
}

.process-model li.visited a,
.process-model li.visited a:hover,
.process-model li.visited a:focus {
  cursor: pointer;
  color: #57b87b;
}

.process-model li p {
  font-size: 14px;
  margin-top: 11px;
}

.process-model li.active p {
  font-weight: 600;
}

.process-model li.active p,
.process-model li.visited p {
  max-width: 100px;
}

.process-model li i {
  display: block;
  height: 68px;
  width: 68px;
  text-align: center;
  margin: 0 auto;
  background: #f5f6f7;
  border: 2px solid #e5e5e5;
  line-height: 65px;
  font-size: 30px;
  border-radius: 50%;
}

.active-wrap {
  background: #1E5DB7;
  background: -webkit-linear-gradient(#1E5DB7, #64A1E1);
  background: -o-linear-gradient(#1E5DB7, #64A1E1);
  background: -moz-linear-gradient(#1E5DB7, #64A1E1);
  background: linear-gradient(#1E5DB7, #64A1E1);
  padding: 5px;
  border-radius: 50%;
  display: inline-block;
}

.visited-wrap {
  background: #57b87b;
  background: -webkit-linear-gradient(#57b87b, #a1c1ac);
  background: -o-linear-gradient(#57b87b, #a1c1ac);
  background: -moz-linear-gradient(#57b87b, #a1c1ac);
  background: linear-gradient(#57b87b, #a1c1ac);
  padding: 5px;
  border-radius: 50%;
  display: inline-block;
}

.process-model li.active i .process-model li.visited i {
  background: #fff;
  border-color: #57b87b;
}

</style>